import { useState, useRef } from "react";
import Config from "../../Config.js";

import g_clear from "../../clear.png";
import g_money from "../../wyprawka/g_money.png";
import g_pampers from "../../wyprawka/g_pampers.png";
import g_pasta from "../../wyprawka/g_pasta.png";
import g_szczoteczka from "../../wyprawka/g_szczoteczka.png";
import g_ubrania from "../../wyprawka/g_ubrania.png";
import g_chusteczki from "../../wyprawka/g_chusteczki.png";
import g_chusteczki_nawilzone from "../../wyprawka/g_chusteczki_nawilzone.png";
import g_mleko from "../../wyprawka/g_milk.png";

import g_clear_ok from "../../clear.png";
import g_money_ok from "../../wyprawka/g_money_2.png";
import g_pampers_ok from "../../wyprawka/g_pampers_2.png";
import g_pasta_ok from "../../wyprawka/g_pasta_2.png";
import g_szczoteczka_ok from "../../wyprawka/g_szczoteczka_2.png";
import g_ubrania_ok from "../../wyprawka/g_ubrania_2.png";
import g_chusteczki_ok from "../../wyprawka/g_chusteczki_2.png";
import g_chusteczki_nawilzone_ok from "../../wyprawka/g_chusteczki_nawilzone_2.png";
import g_mleko_ok from "../../wyprawka/g_milk_2.png";

import InputTextAlpha from "../../helpers/InputTextAlpha.js";
import InputCombo from "../../helpers/InputCombo.js";

import InputComboGrupa from "../../helpers/InputComboGrupaE.js";
import InputDateSlider from "../../helpers/InputDateSlider.js";
import LayetteShow from "./LayetteShow.js";
import LayetteNew from "./LayetteNew.js";


function Layette(props)
{

    var cData = Config.getFromBuffer(Config.cache_grups_emps,3600, props.userData );
    
    const [gr, setGr] = useState(cData);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-CA');

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   
        d_imie_nazwisko:  props.mainView.readFilter('d_imie_nazwisko',''),
        r_imie_nazwisko:  props.mainView.readFilter('r_imie_nazwisko',''), 
        p_grupa_id: '_x_',
        zrealizowano: props.mainView.readFilter('zrealizowano','0'),
        limit: 50,
        page: 1,
        pages: 1,
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    
    const [optionDone, setoptionDone]  = useState([
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '0',
            title: 'Nie'
        }, {
            v: '1',
            title: 'Tak'
        }
    ]
    );
    
    const tabRef = useRef(0); //do druku

    

    

    var defView =  {
        v:'list',
        id: -1
    } ;

    if(props.mainView.idSelected == -2)
    {
        defView =  {
            v:'new',
            id: -1
        } ;
    }

    const [view, setView] = useState ( defView);

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'dziecko przeniesione do archiwum',
            filter: {  filed: "archiwalne", set: "1", typ: "combo"  },
        },
    ]);

    const getGr = () => {
       
 
        props.mainView.setProgress(-2);
    
       
    
        fetch( Config.url + '/rest_v1_employessModule,gr', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 
    
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGr(res.result);      
                        
                        Config.setToBuffer(Config.cache_grups, res.result, props.userData);
                                
                    }
    
            } )
            .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
            });
                   
    
            return false;
    }

    

    

    if( gr == null ||  gr.length == 0 )
    {
            getGr();
            
            return <div></div>;                 
            
    }



    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_employessModule,layetteMobile', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            


                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.imie  + "  " + item.nazwisko,
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);


                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    if(tab == null)
    {
        setTab([]);
        getTab();
        getGr();
     

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }


    
    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }
    
    var selected = new Array();

    var xwindow = null;

    var is_mobile = props.mainView.isMobile();

    if(view.v == 'show')
    {   
        var searchRow ='';

        tab.forEach(element => {
            
            element.wyprawka.forEach(wyprawka_row => {
            
                if(wyprawka_row.id==view.id) { 
                    searchRow = wyprawka_row; 
                }
            });

        });

        /*
        var searchRow = dziecko.wyprawka.map( (row, ix3) => {

            var css_zealizowano = 'layette_incomplete';

            if(row.zrealizowano=='1') css_zealizowano='layette_complete'

            var img = '';

            if(row.inne==1) img = <img onClick={changeView} v="show" id={row.id} className="wyprawka_img" src={g_clear}></img>;
            if(row.chusteczki_nawilzajace==1) img = <img onClick={changeView} v="show" id={row.id} className="wyprawka_img" src={g_chusteczki_nawilzone}></img>;
            if(row.chusteczki_suche	==1) img = <img onClick={changeView} v="show" id={row.id} className="wyprawka_img" src={g_chusteczki}></img>;
            if(row.pampersy==1) img = <img onClick={changeView} v="show" id={row.id} className="wyprawka_img" src={g_pampers}></img>;
            if(row.pasta_do_zebow==1) img = <img onClick={changeView} v="show" id={row.id}className="wyprawka_img" src={g_pasta}></img>;
            if(row.szczoteczka==1) img = <img onClick={changeView} v="show" id={row.id} className="wyprawka_img" src={g_szczoteczka}></img>;
            if(row.zbiorka_pieniedzy==1) img = <img onClick={changeView} v="show" id={row.id} className="wyprawka_img" src={g_money}></img>;
            if(row.mleko==1) img = <img onClick={changeView} v="show" id={row.id} className="wyprawka_img" src={g_mleko}></img>;

            return <div className='kid_row_img' >
                {img}
            </div>
        })
        */

        return <LayetteShow  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack}    />    
        //return false

        //if(is_mobile)
        //    return <KidShowM  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack}    />
        //else
            //
    }

    if(view.v == 'new')
    {
        
        tab.forEach(dziecko => {
            
            
            if(dziecko.id==view.id) { 
                
                var dziecko_data = [];

                dziecko_data.id=dziecko.id;
                dziecko_data.imie=dziecko.imie;
                dziecko_data.nazwisko=dziecko.nazwisko;
                
                selected.push( dziecko );
            }
            

        });

        return <LayetteNew  userData={props.userData} mainView={props.mainView} odbiorcy={selected} onBack={onBack}    />    
    }
    
    if(view.v == 'new_grupa')
    {
        
        tab.forEach(dziecko => {
            
            
            if(dziecko.p_grupa_id==view.id) { 
                
                var dziecko_data = [];

                dziecko_data.id=dziecko.id;
                dziecko_data.imie=dziecko.imie;
                dziecko_data.nazwisko=dziecko.nazwisko;
                
                selected.push( dziecko );
            }
            

        });

        return <LayetteNew  userData={props.userData} mainView={props.mainView} odbiorcy={selected} onBack={onBack}    />    
    }


        var zaznaczonych = 0;
        for(var s=0; s<selectedRow.length; s++)
        {
            if(selectedRow[s].selected == 1) zaznaczonych ++;
        }

    
        var table = '';    
   
        table = gr.map( (grupa, ix) => {

                var grupa_dzieci = tab.filter(tab => tab.grupa === grupa.title);

                
                if(grupa.v!='_x_')

                    

                if(filterParam.p_grupa_id=='_x_' || filterParam.p_grupa_id==grupa.v)    
                {
                    

                    return <div className='mobile_table'>
                    <div className="mobile_th" onClick={changeView} v="new_grupa" id={grupa.v}>{grupa.title} ({grupa_dzieci.length})</div>
                        <div className="mobile_tb">
                        {
                            grupa_dzieci.map( (dziecko, ix2) => {

                                
                                return <div className='kid_row'>
                                    <div className='kid_row_cell item_5' onClick={changeView} v="new" id={dziecko.id}>{ix2+1}</div>
                                    <div className='kid_row_cell' onClick={changeView} v="new" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                    
                                {

                                    

                                dziecko.wyprawka.map( (row, ix3) => {

                                    var css_zealizowano = 'layette_incomplete';

                                    if(row.zrealizowano=='1') css_zealizowano='layette_complete'

                                    var img = '';

                                    if(row.inne==1) {
                                        if(row.zrealizowano=='1') img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_clear_ok}></img>; else img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_clear}></img>;
                                    } 
                                    
                                    if(row.chusteczki_nawilzajace==1) {
                                        if(row.zrealizowano=='1') img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_chusteczki_nawilzone_ok}></img>; else img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_chusteczki_nawilzone}></img>;
                                    }
                                        
                                    
                                    if(row.chusteczki_suche	==1) {
                                        if(row.zrealizowano=='1') img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_chusteczki_ok}></img>; else img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_chusteczki}></img>;
                                    }
                                    
                                    if(row.pampersy==1) {
                                        if(row.zrealizowano=='1') img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_pampers_ok}></img>; else img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_pampers}></img>;
                                    }
                                    
                                    if(row.pasta_do_zebow==1) {
                                        if(row.zrealizowano=='1') img = <img onClick={changeView} v="show" id={row.id}className={' wyprawka_img'} src={g_pasta_ok}></img>; else img = <img onClick={changeView} v="show" id={row.id}className={' wyprawka_img'} src={g_pasta}></img>;
                                    }
                                    
                                    if(row.szczoteczka==1) {
                                        if(row.zrealizowano=='1') img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_szczoteczka_ok}></img>; else img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_szczoteczka}></img>;
                                    }
                                    
                                    if(row.zbiorka_pieniedzy==1) {
                                        if(row.zrealizowano=='1') img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_money_ok}></img>; else img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_money}></img>;
                                    }
                                    
                                    if(row.mleko==1) {
                                        if(row.zrealizowano=='1') img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_mleko_ok}></img>; else img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_mleko}></img>;
                                    }
                                    
                                    if(row.ubrania==1) {
                                        if(row.zrealizowano=='1') img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_ubrania_ok}></img>; else img = <img onClick={changeView} v="show" id={row.id} className={' wyprawka_img'} src={g_ubrania}></img>;
                                    }

                                    return <div className=' kid_row_img' >
                                        {img}
                                    </div>
                                })
                            }

                                </div>
                            })
                        }    
                        </div>
                    </div>
                }
                
                

            }
        )

        
       

    return (

        <div className="view_content">

            {xwindow}

           


            


            <div className="bg_center">
            
                    {table}        
            </div>


        </div>

    )

}

export default Layette;